import React from 'react';
import t from 'rcm-i18n';

interface Props {
    order: any;
}

const ReceiptSignupInfo = ({ order }: Props) => {
    return <>
        {order.attributes.newProfile.rcn &&
            <div className="row profileInfoDisplay">
                <div className="col-xs-12">
                    {order.attributes.newProfile.username !== null &&
                        <div className="row">
                            <div className="col-xs-12">
                                <span className="userInfoLabel">{t('Username')}:&nbsp;</span>
                                <span className="userInfoValue">{order.attributes.newProfile.username}</span>
                            </div>
                        </div>
                    }
                    <div className="row">
                        <div className="col-xs-12">
                            <span className="userInfoLabel">{t('RCN (Reliv Control Number)')}:&nbsp;</span>
                            <span className="userInfoValue newRcn">{order.attributes.newProfile.rcn}</span>
                        </div>
                    </div>
                    {order.attributes.newProfile.sponsorRcn !== null
                        && order.attributes.newProfile.sponsorRcn != order.attributes.guestSignUpRules.sponsorRcn &&
                        <div className="row">
                            <div className="col-xs-12">
                                <span className="userInfoLabel">{t("Sponsor's Name")}:&nbsp;</span>
                                <span className="userInfoValue">{order.attributes.newProfile.sponsorName}</span>
                            </div>
                        </div>
                    }
                </div>
            </div>
        }
    </>;
};

export default ReceiptSignupInfo;
